import dayjs from 'dayjs';

import useWorkspaceStore from '@/stores/WorkspaceStore';
import { getTimezoneDayjs } from '@/utils/time';

export const TimeTest = () => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const timezone = currWorkspace?.timezone;

  const scenario = new Map([
    ['getTimezoneDayjs', getTimezoneDayjs('2025-11-07')],
    ['dayjs with timezone', dayjs('2025-11-07').tz(currWorkspace?.timezone)],
    ['dayjs no timezone', dayjs('2025-11-07').tz()],
    ['dayjs.tz with timezone', dayjs.tz('2025-11-07', currWorkspace?.timezone)],
    ['only date string', dayjs('2025-11-07T00:00:00')],
  ]);

  return (
    <div className="flex flex-col gap-4">
      <div>TimeTest</div>
      <div>Timezone: {timezone}</div>
      <div className="flex flex-col gap-2">
        {Array.from(scenario.entries()).map(([key, value]) => (
          <div key={key} className="flex flex-col gap-2">
            <div>{key}</div>
            <div>{value.toJSON()}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
